/**
 * i18next setup for the Game app.
 *
 * ScenarioSessionInner (from @selna/session-ui) uses react-i18next internally,
 * so we must initialise i18next. Translations for the session UI come from
 * the shared @selna/session-ui package (single source of truth).
 *
 * When multi-language support is added to the game, expand the `resources`
 * object with additional languages from sessionUITranslations.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getSessionUITranslations } from '@selna/session-ui';

i18n.use(initReactI18next).init({
  // Portuguese (Portugal) as the only language for now
  lng: 'pt-PT',
  fallbackLng: 'en-US',

  resources: {
    'pt-PT': {
      translation: getSessionUITranslations('pt-PT'),
    },
    // English fallback for any missing keys
    'en-US': {
      translation: getSessionUITranslations('en-US'),
    },
  },

  interpolation: {
    escapeValue: false, // React already escapes
  },

  react: {
    useSuspense: false,
  },
});

export default i18n;
